import { useContext, useState } from "react";
import addMessage from "./utils/addMessage";
import mikrafonIcon from './images/mikrafon.webp'
import sendMessageIcon from "./images/send_icon.png"
import Messages from "./Messages";
import { AppContext } from "./Context/Context";

function ChatAreaFooter({ chatbotSocket, setMessages, setTyping }) {
    const [inputText, setInputText] = useState('');
    const { handleSendChat } = useContext(AppContext);

    const onChangeHandle = (event) => {
        setInputText(event.target.value);
    };

    const handleOnClick = async () => {
        if (!inputText.trim()) return;

        setTyping(true);

        // 🔑 handleSendChat'dan qaytgan chatId ni kutib olamiz
        const currentChatId = await handleSendChat({
            owner: "user",
            content: inputText
        });

        // UI ga qo‘shib qo‘yamiz
        addMessage({ owner: "user", content: inputText }, setMessages);

        // 🔥 Faqat chatId muvaffaqiyatli olinganidan keyin socketga yuboramiz
        if (currentChatId && currentChatId > 0) {
            chatbotSocket.send(JSON.stringify({ owner: "user", content: inputText }));
        }

        setInputText("");
    };

    const handleEnterBottonDown = (event) => {
        if (event.key === "Enter") {
            document.getElementById("send-icon").click();
            document.getElementById("chat-input-text").value = "";
        }
    };

    return (
        <div className="chat-area-footer">
            <input
                id="chat-input-text"
                value={inputText}
                onKeyDown={handleEnterBottonDown}
                onChange={onChangeHandle}
                type="text"
                placeholder="Xabar yozing..."
            />
            <img onClick={handleOnClick} id="send-icon" src={sendMessageIcon} alt="send" />
            <img id="state-icon" src={mikrafonIcon} alt="mic" />
        </div>
    );
}

export default ChatAreaFooter;
